import React, { forwardRef } from 'react'

import { IconProps } from './types'

const Boolean = forwardRef<SVGSVGElement, IconProps>(
  ({ size, stroke, ...props }, ref) => (
    <svg
      ref={ref}
      width={props.width ?? size}
      height={props.height ?? size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="10" cy="8" r="2" stroke={stroke || 'currentColor'} />
      <rect
        x="2"
        y="4"
        width="12"
        height="8"
        rx="4"
        stroke={stroke || 'currentColor'}
      />
    </svg>
  ),
)
Boolean.displayName = 'Boolean'

export default Boolean
